import React from 'react'
import {StyledContainer, StyledInnerContainer, StyledTitleContainer, StyledText} from './GeneraTeLinksStyle'
import GenerateLinkDetail from "../../../components/GenerateLinkDetail/GenerateLinkDetail"
import generateStep1 from '../../../resources/images/generate-step-1.svg'
import generateStep2 from '../../../resources/images/generate-step-2.svg'
import generateStep3 from '../../../resources/images/generate-step-3.svg'
import ComponentTitle from "../../../components/ComponentTitle/ComponentTitle"
import { useTranslation } from "react-i18next";

const GenerateLinks = () => {
    const { t } = useTranslation();
    return (
        <StyledContainer>
            <StyledTitleContainer>
              <ComponentTitle value='generateLink'/>
              <StyledText> 
                {t('generateLinkDescription')}
              </StyledText>
            </StyledTitleContainer>
            <StyledInnerContainer>
                <GenerateLinkDetail step={1} description={"generateStep1"} img={generateStep1}/>
                <GenerateLinkDetail step={2} description={"generateStep2"} img={generateStep2}/>
                <GenerateLinkDetail step={3} description={"generateStep3"} img={generateStep3}/>
            </StyledInnerContainer>
        </StyledContainer>
    )
}

export default GenerateLinks